var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _path15, _g8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterHalatech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 15,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1653 1.52734H1.67578V16.4831H15.1653V1.52734Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6137 -3.82739H-4.05078V25.7149H48.6137V-3.82739Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0893 0.604004H0.751953V17.4062H16.0893V0.604004Z",
    fill: "#DB4E45"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6118 -3.82715H-4.05273V25.7151H48.6118V-3.82715Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1653 1.52734H1.67578V16.4831H15.1653V1.52734Z",
    stroke: "#DB4E45",
    strokeWidth: 0.726562,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 4,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89062 14.6367H6.66244V10.9956H6.07297V14.0514H4.46347V4.14182H6.07297V7.21237H6.66244V3.55835H3.89062V14.6367Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6118 -3.82739H-4.05273V25.7149H48.6118V-3.82739Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58844 2.63501H2.96875V15.5598H7.58844V2.63501Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00195 8.17433H10.9152V3.55835H10.3645V7.62964H5.56925V4.5831H5.00195V8.17433Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6137 -3.82739H-4.05078V25.7149H48.6137V-3.82739Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8392 2.63501H4.07812V9.09738H11.8392V2.63501Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 9,
    width: 6,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00195 9.83643H10.9152V14.4524H10.3645V10.3793H5.56925V13.4258H5.00195V9.83643Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6137 -3.82715H-4.05078V25.7151H48.6137V-3.82715Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8392 8.91309H4.07812V15.3755H11.8392V8.91309Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 8,
    height: 7
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8383 14.4521V14.1087V8.72827H4.81641V9.27296H11.2766L11.2803 14.4521H11.8383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6098 -3.82739H-4.05469V25.7149H48.6098V-3.82739Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.7624 7.80493H3.89258V15.3751H12.7624V7.80493Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 3,
    width: 3,
    height: 12
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5775 14.4521H13.1318V3.55835H11.4688V8.29988H12.0379V4.14182H12.5775V14.4521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6118 -3.82739H-4.05273V25.7149H48.6118V-3.82739Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.0559 2.63501H10.5449V15.3751H14.0559V2.63501Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 13,
    width: 2,
    height: 2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.577 13.8984H11.8379V14.4524H12.577V13.8984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2048_405)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_2048_405",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -4,
    width: 54,
    height: 30
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6137 -3.82739H-4.05078V25.7149H48.6137V-3.82739Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_2048_405)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.503 12.9749H10.916V15.3752H13.503V12.9749Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2048_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 16.7917,
    fill: "white",
    transform: "translate(0.75 0.604248)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterHalatech);
export default __webpack_public_path__ + "static/media/footer-halatech.4e4f3c2c8fadc1096cccc040aff72da0.svg";
export { ForwardRef as ReactComponent };